import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DialogActions, Grid, Dialog, DialogContent,
  Step, StepLabel, Stepper, Typography
} from '@material-ui/core';
import { TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { obtenerPermisosValor, obtenerValoresFiltros, crear_form_data } from "../../../global/js/funciones";
import AppBarModal from '../../general/AppBarModal';
import { BtnForm } from "../../general/BotonesAccion";
import CustomDropzone from "../../general/CustomDropzone";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from './../../../global/imagenes/emma_w.png';
import BuscarPersona from '../../general/BuscarPersona';
import AlertasSimple from '../../general/AlertasSimple';

const PASOS = [
  { codigo: 'Est_Centro_Env',            label: 'Sin Asignar'     },
  { codigo: 'Est_Centro_Aprob',          label: 'Aprobado'        },
  { codigo: 'Est_Centro_Asig',           label: 'Asignado'        },
  { codigo: 'Est_Centro_Tramite',        label: 'Trámite'         },
  { codigo: 'Est_Centro_CargarActaCons', label: 'Acta/Constancia' },
  { codigo: 'Est_Centro_Finalizar',      label: 'Finalizado'      },
];

const RESULTADOS_AUDIENCIA = [
  { value: 'Est_Centro_Finalizado_acta_concili',              label: 'Acta de Conciliación'                          },
  { value: 'Est_Centro_Finalizado_acta_concili_Total',        label: 'Acta de Conciliación Total'                    },
  { value: 'Est_Centro_Finalizado_acta_concili_Parcial',      label: 'Acta de Conciliación Parcial'                  },
  { value: 'Est_Centro_Finalizado_Constan_No_acuerdo',        label: 'Constancia: No acuerdo'                        },
  { value: 'Est_Centro_Finalizado_Cons_Inasis_una_de_partes', label: 'Constancia: Inasistencia de una de las partes' },
  { value: 'Est_Centro_Finalizado_Cons_Inasis_ambas_partes',  label: 'Constancia: Inasistencia de ambas partes'      },
  { value: 'Est_Centro_Finalizado_Otros_resultados',          label: 'Otros resultados'                              },
];

const CODIGOS_FINALIZADO = new Set(RESULTADOS_AUDIENCIA.map(r => r.value));

function StepperCentro({ codigoActual }) {
  const pasoActual = PASOS.findIndex(p => p.codigo === codigoActual);
  return (
    <Stepper activeStep={pasoActual} alternativeLabel style={{ padding: '16px 8px', background: 'transparent' }}>
      {PASOS.map(({ label }, i) => (
        <Step key={label} completed={i < pasoActual}>
          <StepLabel
            StepIconProps={{
              style: {
                color: i < pasoActual ? '#4caf50' : i === pasoActual ? '#C62828' : '#bdbdbd'
              }
            }}
          >
            <span style={{ fontSize: 11 }}>{label}</span>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

class CentroGestionar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: true,
      estado: '',
      motivo: '',
      observacion: '',
      estados_siguiente: [],
      archivos: [],
      formatos_archivos: '',
      buscarGestor: false,
      gestor: { id: 0, nombre_completo: 'Clic aquí para buscar' },
      resultado_audiencia: '',
      procesoLocal: null,
    };
  }

  async componentDidUpdate({ modalGestionarCentro }) {
    let { modalGestionarCentro: modalNew, proceso } = this.props;
    // Solo cuando el modal ABRE
    if (!modalGestionarCentro && modalNew) {
      await this.cargarDatos(proceso);
    }
  }

  cargarDatos = async (proceso) => {
    this.setState({ cargando: true });
    let formatos_archivos = await obtenerValoresFiltros([{ llave: 'codigo', valor: 'For_Arc_Centro' }]);
    let estados_siguiente = proceso && proceso.estado_actual
      ? await obtenerPermisosValor(proceso.estado_actual.id)
      : [];
    this.setState({
      procesoLocal: proceso,
      estado: '', motivo: '', observacion: '', archivos: [],
      gestor: { id: 0, nombre_completo: 'Clic aquí para buscar' },
      resultado_audiencia: '',
      estados_siguiente,
      cargando: false,
      formatos_archivos: formatos_archivos && formatos_archivos[0] ? formatos_archivos[0].valora : '',
    });
  }

  onChange = ({ target }) => this.setState({ [target.name]: target.value });

  agregarArchivos = (arc) => this.setState(prev => ({ archivos: prev.archivos.concat(arc) }));

  eliminarArchivo = (i) => {
    let archivos = [...this.state.archivos];
    archivos.splice(i, 1);
    this.setState({ archivos });
    this.props.actualizarMensaje({ titulo: 'Archivo Retirado.', tipo: 'success', mostrar: true, tiempo: 6000 });
  }

  enviarDatos = () => {
    let { actualizarMensaje } = this.props;
    let { estado, motivo, gestor, observacion } = this.state;

    if (!estado)
      return actualizarMensaje({ titulo: 'Debe seleccionar un estado.', tipo: 'info', mostrar: true, tiempo: 6000 });
    if (estado === 'Est_Centro_Nega' && !motivo)
      return actualizarMensaje({ titulo: 'Debe especificar el motivo de negación.', tipo: 'info', mostrar: true, tiempo: 6000 });
    if (estado === 'Est_Centro_Asig' && gestor.id === 0)
      return actualizarMensaje({ titulo: 'Debe asignar un Gestor.', tipo: 'info', mostrar: true, tiempo: 6000 });
    if (['Est_Centro_Aprob', 'Est_Centro_Tramite', 'Est_Centro_CargarActaCons', 'Est_Centro_correccion'].includes(estado) && !observacion)
      return actualizarMensaje({ titulo: 'Debe escribir las observaciones.', tipo: 'info', mostrar: true, tiempo: 6000 });
    if (CODIGOS_FINALIZADO.has(estado) && !observacion)
      return actualizarMensaje({ titulo: 'Debe escribir las observaciones.', tipo: 'info', mostrar: true, tiempo: 6000 });

    this.onSubmit();
  }

  onSubmit = () => {
    let { procesoLocal, estado, motivo, archivos, gestor, observacion, resultado_audiencia } = this.state;
    let archivosSnapshot = [...archivos];
    this.setState({ cargando: true });
    let data = { motivo, observacion, estado, gestor: gestor.id, archivos: archivosSnapshot, total: archivosSnapshot.length };

    this.props.gestionarCentro(procesoLocal.id, data, async (exito, procesoActualizado) => {
      if (exito && procesoActualizado) {
        // Recargar estados del nuevo estado — modal permanece abierto
        let estados_siguiente = procesoActualizado.estado_actual
          ? await obtenerPermisosValor(procesoActualizado.estado_actual.id)
          : [];
        this.setState({
          cargando: false,
          procesoLocal: procesoActualizado,
          estado: '', motivo: '', observacion: '', archivos: [],
          gestor: { id: 0, nombre_completo: 'Clic aquí para buscar' },
          resultado_audiencia: '',
          estados_siguiente,
        });
        if (CODIGOS_FINALIZADO.has(data.estado) && data.estado !== 'Est_Centro_Finalizado_acta_concili') {
          this.props.mostrarModalGestionarCentro(false);
        }
      } else {
        this.setState({ cargando: false });
      }
    });
  }

  pintarFormulario() {
    let { estado, estados_siguiente, gestor, motivo, observacion, procesoLocal, resultado_audiencia } = this.state;
    const codigoActual = procesoLocal && procesoLocal.estado_actual
      ? procesoLocal.estado_actual.codigo : 'Est_Centro_Env';
    const pasoLabel = PASOS.find(p => p.codigo === codigoActual);

    return (
      <Grid container spacing={2} style={{ padding: '0 8px' }}>

        <Grid item xs={12}>
          <StepperCentro codigoActual={codigoActual} />
        </Grid>

        {pasoLabel && (
          <Grid item xs={12}>
            <Typography variant="subtitle1" style={{ color: '#B71C1C', fontWeight: 600 }}>
              Paso actual: {pasoLabel.label}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography variant="body2" style={{ marginBottom: 8, color: '#555' }}>
            Seleccione el siguiente estado:
          </Typography>
          <Grid container spacing={1}>
            {estados_siguiente.map(({ secundario }) => {
              const { codigo, nombre } = secundario;
              const seleccionado = estado === codigo;
              const esNegar = codigo === 'Est_Centro_Nega';
              return (
                <Grid item xs={12} sm={6} key={codigo}>
                  <div
                    onClick={() => this.setState({ estado: codigo })}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 10,
                      padding: '12px 16px', borderRadius: 8, cursor: 'pointer',
                      border: `2px solid ${seleccionado ? (esNegar ? '#b71c1c' : '#C62828') : '#e0e0e0'}`,
                      background: seleccionado ? (esNegar ? '#ffebee' : '#fff3f3') : '#fafafa',
                      transition: '0.2s',
                    }}
                  >
                    {seleccionado
                      ? (esNegar ? <CancelIcon style={{ color: '#b71c1c' }} /> : <CheckCircleIcon style={{ color: '#4caf50' }} />)
                      : <div style={{ width: 24, height: 24, borderRadius: '50%', border: '2px solid #bdbdbd' }} />
                    }
                    <span style={{ fontSize: 14, fontWeight: seleccionado ? 600 : 400 }}>{nombre}</span>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </Grid>

        {estado === 'Est_Centro_Nega' && (
          <Grid item xs={12}>
            <TextField
              label="Motivo de Negación" name="motivo" value={motivo}
              placeholder="Escriba el motivo de la negación"
              multiline rows={3} fullWidth variant="outlined"
              onChange={this.onChange}
            />
          </Grid>
        )}

        {estado === 'Est_Centro_Asig' && (
          <Grid item xs={12}>
            <Grid container spacing={1} alignItems="flex-end"
              onClick={() => this.setState({ buscarGestor: true })}
              style={{ cursor: 'pointer', padding: '8px 0' }}
            >
              <Grid item xs={11}>
                <TextField
                  label="Conciliador / Gestor asignado" disabled type="text"
                  value={gestor.nombre_completo} fullWidth variant="outlined"
                />
              </Grid>
              <Grid item xs={1}>
                <SearchIcon style={{ color: '#C62828', fontSize: 28 }} />
              </Grid>
            </Grid>
          </Grid>
        )}

        {(estado === 'Est_Centro_Tramite' || estado === 'Est_Centro_CargarActaCons' || estado === 'Est_Centro_correccion' || CODIGOS_FINALIZADO.has(estado)) && (
          <Grid item xs={12}>
            <AlertasSimple
              tipo='info'
              titulo={
                estado === 'Est_Centro_CargarActaCons'
                  ? 'Adjunte el Acta / Constancia correspondiente y complete el campo "Observación", registrando las acciones realizadas y cualquier información relevante del proceso. El diligenciamiento de ambos campos es obligatorio.'
                  : CODIGOS_FINALIZADO.has(estado)
                  ? 'Adjunte el documento correspondiente al resultado de la audiencia y diligencie el campo "Observación" con un resumen de las actuaciones realizadas.'
                  : estado === 'Est_Centro_correccion'
                  ? 'Adjunte la documentación con las correcciones requeridas y diligencie el campo "Observación" indicando los ajustes realizados.'
                  : 'Adjunte los documentos correspondientes (Carta de aceptación del rol y los archivos editables del Centro). Además, es obligatorio diligenciar el campo "Observación", donde se debe describir de manera clara y detallada las actividades realizadas durante el proceso.'
              }
              margin='0px'
            />
            <div style={{ marginTop: 12 }}>
              <CustomDropzone
                archivos={this.state.archivos}
                addFunction={this.agregarArchivos}
                deleteFunction={this.eliminarArchivo}
                actualizarMensaje={this.props.actualizarMensaje}
                acceptedFiles={this.state.formatos_archivos}
              />
            </div>
          </Grid>
        )}

        {estado && estado !== 'Est_Centro_Nega' && (
          <Grid item xs={12}>
            <TextField
              label="Observaciones" name="observacion" value={observacion}
              multiline rows={4} fullWidth variant="outlined"
              onChange={this.onChange}
            />
          </Grid>
        )}

        {!estado && (
          <Grid item xs={12}>
            <AlertasSimple
              tipo='info'
              titulo='Seleccione el estado al que desea mover esta solicitud para continuar con la gestión.'
              margin='0px'
            />
          </Grid>
        )}

      </Grid>
    );
  }

  render() {
    let { modalGestionarCentro, mostrarModalGestionarCentro } = this.props;
    let { cargando, buscarGestor } = this.state;
    return (
      <>
        <Dialog fullWidth maxWidth="md" open={modalGestionarCentro}
          onClose={() => mostrarModalGestionarCentro(false)}
        >
          <AppBarModal titulo='¿ Gestionar Centro ?' mostrarModal={mostrarModalGestionarCentro} titulo_accion="" accion="" />
          <DialogContent className='scroll' style={{ padding: '8px 16px' }}>
            {cargando
              ? <TareasTerminadas mensaje='Cargando...' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
              : this.pintarFormulario()
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={() => mostrarModalGestionarCentro(false)} />
            {!cargando && <BtnForm texto="GUARDAR" callback={this.enviarDatos} />}
          </DialogActions>
        </Dialog>

        <Dialog fullWidth maxWidth="sm" fullScreen={window.innerWidth < 600}
          open={buscarGestor} onClose={() => this.setState({ buscarGestor: false })}
        >
          <AppBarModal titulo='¡ Buscar Conciliador / Gestor !'
            mostrarModal={() => this.setState({ buscarGestor: false })}
            titulo_accion="CERRAR" accion={() => this.setState({ buscarGestor: false })}
          />
          <DialogContent style={{ padding: 0 }} className='scroll'>
            <BuscarPersona callback={({ id, primer_nombre, primer_apellido, segundo_apellido }) =>
              this.setState({
                gestor: { id, nombre_completo: `${primer_nombre} ${primer_apellido} ${segundo_apellido}` },
                buscarGestor: false,
              })
            } />
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={() => this.setState({ buscarGestor: false })} />
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

CentroGestionar.propTypes = {
  modalGestionarCentro: PropTypes.bool.isRequired,
  mostrarModalGestionarCentro: PropTypes.func.isRequired,
};

export default CentroGestionar;
